// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"fb7f15dd","697":"7eb7c262","702":"dd993e31"}[chunkId] + ".chunk.js";
};